import { endpointsGlob } from "./endpoints";

const rootArea = "/proxies";

export const proxiesGlob = () => ({
	self: rootArea,
	byType: (type: string) => ({ 	
		self: `${rootArea}/${type}`,					
		read: `${rootArea}/${type}/read`,					
		endpoints: endpointsGlob(`${rootArea}/${type}`)
	})
});